<template>
    <div>
      
    </div>
</template>

<script>


export default {
  name: 'AllGames',
  data(){
      return{
        
      }
  },

   
}

</script>

<style scoped>

</style>
